import { InteractivityDesignDimensionsService } from '../services/interactivity-design-dimensions.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';

import { AuthGuard } from '../../../../guards/auth.guard';
import { SharedModule } from '../../../../modules/shared.module';
import { BbTableModule } from '../../../../modules/bb-table.module';
import { PipesModule } from '../../../../modules/pipes.module';
import { MaterialModule } from '../../../../modules/material.module';
import { ColorPickerModule } from 'ngx-color-picker';

import { InteractivityActionService } from '../services/interactivity-action.service';
import { InteractivityDataSourceService } from '../services/interactivity-data-source.service';
import { InteractivityEditorService } from '../services/interactivity-editor.service';
import { InteractivityMediaService } from '../services/interactivity-media.service';
import { InteractivityStateService } from '../services/interactivity-state.service';
import { InteractivityWidgetService } from '../services/interactivity-widget.service';
import { InteractivityWidgetSelectionService } from '../services/interactivity-widget-selection.service';
import { InteractivityWidgetAnimationService } from '../services/interactivity-widget-animation.service';
import { InteractivityWidgetDefinitionService } from '../services/interactivity-widget-definition.service';
import { InteractivityStageService } from '../services/interactivity-stage.service';

import { PropertyBarComponent } from '../components/property-bar/property-bar.component';
import { PlayerComponent } from '../components/player/player.component';
import { StageComponent } from '../components/stage/stage.component';
import { TimelineComponent } from '../components/timeline/timeline.component';
import { TimeRulerComponent } from '../components/timeline/time-ruler.component';
import { TimepointComponent } from '../components/timeline/timepoint.component';
import { TimepointTrackComponent } from '../components/timeline/timepoint-track.component';
import { TracksComponent } from '../components/timeline/tracks.component';
import { TrackComponent } from '../components/timeline/track.component';
import { TrackElementComponent } from '../components/timeline/track-element.component';
import { InteractivityEditorComponent } from '../interactivity-editor.component';
import { PlayerBarComponent } from '../components/player-bar/player-bar.component';
import { StageWidgetComponent } from '../components/stage/stage.widget.component';
import { GridVisualComponent } from '../components/stage/grid-visual.component';
import { WidgetBarComponent } from '../components/widget-bar/widget-bar.component';
import { ButtonBarComponent } from '../components/button-bar/button-bar.component';
import { InspectorComponent } from '../components/inspector/inspector.component';
import { IeDesignDimensionsComponent } from '../components/ie-design-dimensions/ie-design-dimensions.component';
import { IeAlignDistributeComponent } from '../components/ie-align-distribute/ie-align-distribute.component';
import { IEFormConfigComponent } from '../components/ie-form-config/ie-form-config.component';
import { IEWidgetFieldsComponent } from '../components/ie-widget-fields/ie-widget-fields.component';
import { EventHandlerComponent } from '../components/event-handler/event-handler.component';
import { ProcedureComponent } from '../components/event-handler/procedure/procedure.component';
import { AddProcedureComponent } from '../components/event-handler/procedure/add-procedure.component';
import { ActionComponent } from '../components/event-handler/procedure/action/action.component';
import { ConditionVariableComponent } from '../components/event-handler/procedure/condition/condition-variable.component';
import { ConditionComponent } from '../components/event-handler/procedure/condition/condition.component';
import { PortfolioComponent} from '../components/portfolio/portfolio.component';


const moduleRoutes: Routes = [
	{
		path: 'interactivity',
		component: InteractivityEditorComponent,
		canActivate: [AuthGuard],
		children: []
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(moduleRoutes),
		CommonModule,
		SharedModule,
		PipesModule,
		MaterialModule,
		FormsModule,
		BbTableModule,
		MaterialModule,
		MatSelectModule,
		ColorPickerModule,
	],
	declarations: [
		InteractivityEditorComponent,
		PropertyBarComponent,
		StageComponent,
		InspectorComponent,
		IeDesignDimensionsComponent,
		IeAlignDistributeComponent,
		IEFormConfigComponent,
		IEWidgetFieldsComponent,
		ProcedureComponent,
		AddProcedureComponent,
		ActionComponent,
		PortfolioComponent,
		ConditionComponent,
		ConditionVariableComponent,
		EventHandlerComponent,
		StageWidgetComponent,
		GridVisualComponent,
		PlayerComponent,
		PlayerBarComponent,
		WidgetBarComponent,
		TimelineComponent,
		TimeRulerComponent,
		TimepointComponent,
		TimepointTrackComponent,
		TracksComponent,
		TrackComponent,
		TrackElementComponent,
		ButtonBarComponent,
	],
	exports: [
		InteractivityEditorComponent
	],
	// entryComponents: [
	// 	InteractivityEditorComponent
	// ],
	providers: [
		InteractivityActionService,
		InteractivityDataSourceService,
		InteractivityEditorService,
		InteractivityMediaService,
		InteractivityStateService,
		InteractivityWidgetService,
		InteractivityWidgetSelectionService,
		InteractivityWidgetAnimationService,
		InteractivityWidgetDefinitionService,
		InteractivityStageService,
		InteractivityDesignDimensionsService
	]
})
export class InteractivityEditorModule {
	/* nothing */
}
